import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const buildRange = (page, total) => {
  const out = [];
  for (let p = 1; p <= total; p++) {
    if (p === 1 || p === total || Math.abs(p - page) <= 1) out.push(p);
    else if (out[out.length - 1] !== "...") out.push("...");
  }
  return out;
};

export const Pagination = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;
  const range = buildRange(page, totalPages);
  const btn = "min-w-9 h-9 px-2 rounded-lg text-sm font-semibold flex items-center justify-center transition-colors";
  return (
    <nav data-testid="pagination" className="flex items-center justify-center gap-1.5 mt-12">
      <button
        data-testid="page-prev"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${btn} border border-slate-200 text-slate-600 hover:border-[#F26B2A] hover:text-[#F26B2A] disabled:opacity-40 disabled:pointer-events-none`}
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      {range.map((p, i) =>
        p === "..." ? (
          <span key={`e${i}`} className="px-1 text-slate-400">…</span>
        ) : (
          <button
            key={p}
            data-testid={`page-${p}`}
            onClick={() => onChange(p)}
            className={`${btn} ${
              p === page
                ? "bg-gradient-to-r from-[#F26B2A] to-[#F59B42] text-white shadow-sm"
                : "border border-slate-200 text-slate-600 hover:border-[#F26B2A] hover:text-[#F26B2A]"
            }`}
          >
            {p}
          </button>
        )
      )}
      <button
        data-testid="page-next"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btn} border border-slate-200 text-slate-600 hover:border-[#F26B2A] hover:text-[#F26B2A] disabled:opacity-40 disabled:pointer-events-none`}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </nav>
  );
};
